import { makeObservable, observable } from 'mobx'

import {
  IAttachment,
  IChecklistAnswerItem,
  IFormMaterial,
  IFormMaterialResource,
  IMeasure,
  IPermitFieldInterface,
  IRichText,
  ISignature,
  ISiteLocation,
  ITableRowPermitField,
  PermitFieldType,
} from '~/client/graph'

import IPermitFieldDto from './IPermitFieldDto'

export default class PermitField implements IPermitFieldInterface {
  public static fromDto(
    dto: IPermitFieldDto,
    shouldSkipTable?: boolean,
  ): PermitField {
    return new PermitField(
      dto.instanceId,
      dto.fieldId,
      dto.type,
      dto.parentInstanceId,
      dto.parentValueIndex,
      dto.attachmentValues,
      dto.checklistValues,
      dto.dateTimeValues,
      dto.locationValues,
      dto.measureValues,
      dto.stringValues,
      dto.objectIdValues,
      shouldSkipTable ? [] : dto.tableValues,
      dto.materialValues,
      dto.richTextValues,
      dto.signatureValues,
      dto.materialResourceValues,
    )
  }

  @observable public instanceId: string = null
  @observable public fieldId: string = null
  @observable public type: PermitFieldType = null
  @observable public values: any[] = []
  @observable public parentInstanceId?: string = null
  @observable public parentValueIndex?: number = null

  public constructor(
    instanceId: string,
    fieldId: string,
    type: PermitFieldType,
    parentInstanceId?: string,
    parentValueIndex?: number,
    attachmentValues?: IAttachment[],
    checklistValues?: IChecklistAnswerItem[],
    dateTimeValues?: number[],
    locationValues?: ISiteLocation[],
    measureValues?: IMeasure[],
    stringValues?: string[],
    objectIdValues?: string[],
    tableValues?: ITableRowPermitField[],
    materialValues?: IFormMaterial[],
    richTextValues?: IRichText[],
    signatureValues?: ISignature[],
    materialResourceValues?: IFormMaterialResource[],
  ) {
    this.instanceId = instanceId
    this.fieldId = fieldId
    this.type = type
    this.parentInstanceId = parentInstanceId
    this.parentValueIndex = parentValueIndex

    this.values = [
      ...(attachmentValues || []),
      ...(checklistValues || []),
      ...(dateTimeValues || []),
      ...(locationValues || []),
      ...(measureValues || []),
      ...(stringValues || []),
      ...(objectIdValues || []),
      ...(tableValues?.map(tableRow =>
        tableRow.cells.map(f => PermitField.fromDto(f, true)),
      ) || []),
      ...(materialValues || []),
      ...(richTextValues || []),
      ...(signatureValues || []),
      ...(materialResourceValues || []),
    ]
    makeObservable(this)
  }
}
